import { Logger } from '@hawtiosrc/core/logging'

export const log = Logger.get('hawtio-ui-page')
